<template>
  <div class="pc-university">
    <!-- 院校头部面包屑部分 -->
    <BreadCrumb :data="breadcrumb" :title="'院校列表管理'" />
    <StatisticalPanel
      :whichModule="'universities'"
      :data="overallData"
    ></StatisticalPanel>
    <div class="pc-university-table">
      <UniversityTable />
    </div>
  </div>
</template>
<script>
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import UniversityTable from "./components/UniversityTable";

import {
  getUniversityCount_Api,
  UniversitySearch_Api,
} from "../../../apis/university.api";
export default {
  components: {
    BreadCrumb,
    UniversityTable,
    StatisticalPanel,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "院校列表", link: "/admin/school" },
      ];
    },
  },
  data() {
    return {
      overallData: {
        title: "院校数据",
        count: [
          { name: "院校入库", count: null },
          { name: "WUPEN院校联盟", count: null },
        ],
      },
      topics: { module: "院校", class: [{ name: "Topics", subTitles: [] }] },
      university_count: 0,
      wupen_university_count: 0,
    };
  },
  created() {},
  mounted() {
    getUniversityCount_Api().then((res) => {
      this.$set(this.overallData.count[0], "count", res.data.university_count);
      this.$set(
        this.overallData.count[1],
        "count",
        res.data.wupen_university_count
      );
    });
    this.UniversitySearch();
  },
  methods: {
    UniversitySearch() {
      UniversitySearch_Api().then((res) => {
        this.$set(this.topics.class[0], "subTitles", res.data);
        console.log(this.topics);
        console.log(res.data);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/university/UniversityList.vue